import GuidePreview from "components/GuidePreview/GuidePreview";
import useResolvedGuideTemplateStagesWithExampleContext from "components/GuidePreview/utils/useResolvedGuideTemplateStagesWithExampleContext";
import {
  GuideTemplatesForSelect_currentOrganization as Organization,
  GuideTemplatesForSelect_currentOrganization_guideTemplates as GuideTemplate,
} from "generated/schemaTypes";

type GuideTemplatePreviewSectionProps = {
  guideTemplate: GuideTemplate;
  organization: Organization;
};

function GuideTemplatePreviewSection({
  guideTemplate,
  organization,
}: GuideTemplatePreviewSectionProps) {
  const { stages } =
    useResolvedGuideTemplateStagesWithExampleContext(guideTemplate) ?? [];

  return (
    <GuidePreview
      header={() => <div />}
      stages={stages?.filter((s) => s.resolvedModules.length > 0) ?? []}
      organization={organization}
      stageStepperEnabled={guideTemplate.interviewProcessEnabled}
      className="pt-12 overflow-hidden"
      showFooter={false}
    />
  );
}

GuideTemplatePreviewSection.fragments = {
  organization: GuidePreview.fragments.organization,
  guideTemplate: GuidePreview.fragments.guideTemplate,
};

export default GuideTemplatePreviewSection;
